import { render, staticRenderFns } from "./SubscriptionExpired.vue?vue&type=template&id=96d9014e"
import script from "./SubscriptionExpired.vue?vue&type=script&lang=js"
export * from "./SubscriptionExpired.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports